"use client"
//import SinAuth from "../templates/SinAuth";
import ContenidoPublico from "../templates/ContenidoPublico";

import { connect } from "react-redux";
import dynamic from 'next/dynamic';


import BlocksPublicURLShared from "../components/BlocksPublicURLShared";
//import "primereact/resources/primereact.css";
//import "primeicons/primeicons.css";
//import "primeflex/primeflex.css";
//import "prismjs/themes/prism-coy.css";
//import "../assets/demo/flags/flags.css";
//import "../assets/demo/Demos.scss";
//import "../assets/layout/layout.scss";
//import "../App.scss";

import React from 'react';

//import { configSubdomain, useAuthDispatch, logout, useAuthState } from '../context';


const PublicURLShared = (props) => {
    console.log("PublicURLShared22.js");

    //const dispatch = useAuthDispatch();
    //const userDetails = useAuthState();

    //const { subdomain, userName, idSuscripcion, idEmpresa, idioma } = userDetails;

    return (
        <ContenidoPublico>
            <BlocksPublicURLShared />
        </ContenidoPublico>
    );
};

//export default PublicURLShared;
//export default connect(null)(PublicURLShared);

export default dynamic(() => Promise.resolve(connect(null)(PublicURLShared)), {ssr: false});
